import { combineReducers } from 'redux-loop';
// import { routeReducer as router } from 'react-router-redux';
import router from 'modules/router/reducer';
import { reducer as elog } from 'modules/elog';
import { reducer as base } from 'modules/base';
import { reducer as me } from 'modules/me';
import { reducer as home } from 'modules/home';
import { reducer as eadmin } from 'modules/eadmin';
import { reducer as collection } from 'modules/collection';
import { reducer as mediaType } from 'modules/mediaType';
import { reducer as modal } from 'modules/modal';
import { reducer as subject } from 'modules/subject';
import { reducer as sourceGroup } from 'modules/sourceGroup';
import { reducer as sourceArea } from 'modules/sourceArea';
import { reducer as carousel } from 'modules/carousel';
import { reducer as search } from 'modules/search';
import { reducer as advancedSearch } from 'modules/advancedSearch';

export default combineReducers({
  router,
  base,
  home,
  modal,
  me,
  eadmin,
  collection,
  mediaType,
  subject,
  sourceGroup,
  sourceArea,
  carousel,
  search,
  advancedSearch,
  elog
});



/** WEBPACK FOOTER **
 ** ./src/app/modules/app/reducer.js
 **/